import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/MyPage.css";
import axios from "axios";
import { handleLogout } from "../utils/logout";
import Footer from "./Footer";
import Header from "./Header";

function MyPage() {
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState("");
    const [resetPasswordBox, setResetPasswordBox] = useState(false);
    const [password, setPassword] = useState("");
    const [checkPassword, setCheckPassword] = useState("");
    const [DeletePasswordBox, setDeletePasswordBox] = useState(false);
    const [name, setName] = useState(null);
    const [birthDate, setBirthDate] = useState(null);
    const [id, setId] = useState(null);
    const [email, setEmail] = useState(null);
    const [passwordState, setPasswordState] = useState(true);
    const [newPasswordState, setNewPasswordState] = useState(true);
    const [checkPasswordState, setCheckPasswordState] = useState(true);
    const [lengthPasswordState, setLengthPasswordState] = useState(true);
    const [samePasswordState, setSamePasswordState] = useState(true);
    const [deletePasswordState, setDeletePasswordState] = useState(true);
    const [deletePassword, setDeletePassword] = useState("");
    const [errorResetMsg, setErrorResetMsg] = useState("");
    const [errorDeleteMsg, setErrorDeleteMsg] = useState("");
    const [provider, setProvider] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [passwordStrength, setPasswordStrength] = useState(0);
    const [showPwRule, setShowPwRule] = useState(false);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_SPRING_API_URL}/api/session-user`, {
                withCredentials: true,
            })
            .then((res) => {
                axios
                    .get(
                        `${process.env.REACT_APP_SPRING_API_URL}/api/userData/${res.data.username}`
                    )
                    .then((response) => {
                        setName(response.data.name);
                        setBirthDate(response.data.birthDate);
                        setId(response.data.username);
                        setEmail(response.data.email);
                        setProvider(response.data.provider);
                    })
                    .catch((err) => {
                        console.log(err);
                        alert(`오류가 발생하였습니다.\n${err}`);
                        navigate("/");
                    });
            })
            .catch((err) => {
                alert(`오류가 발생하였습니다.\n${err}`);
                navigate("/");
            });
    }, [navigate]);

    const handleDeleteUser = () => {
        setErrorDeleteMsg("");

        const skipCurrentPasswordCheck = provider !== null && provider !== "";

        if (!deletePassword && !skipCurrentPasswordCheck) {
            setDeletePasswordState(false);
            return;
        } else {
            setDeletePasswordState(true);
        }

        const confirmDelete = window.confirm("정말 회원 탈퇴를 진행하시겠습니까?");
        if (!confirmDelete) return;

        const userData = {};

        // provider가 없으면 password 필수
        if (!skipCurrentPasswordCheck) {
            userData.password = deletePassword;
        }

        const url = `${process.env.REACT_APP_SPRING_API_URL}/api/deleteUser`;

        axios
            .delete(url, { data: userData, withCredentials: true })
            .then(() => {
                alert("탈퇴되었습니다. 감사합니다 🫶");
                handleLogout(navigate, setId, setName, setBirthDate);
            })
            .catch((error) => {
                const msg = error.response?.data || "오류가 발생했습니다.";
                setErrorDeleteMsg(msg);
            });
    };

    const handleResetPassword = () => {
        setErrorResetMsg("");

        // provider가 있는 경우 현재 비밀번호 체크 무시
        const skipCurrentPasswordCheck = provider !== null && provider !== "";

        let pw = skipCurrentPasswordCheck ? true : Boolean(password);
        let newPw = Boolean(newPassword);
        let checkPw = Boolean(checkPassword);

        setPasswordState(pw);
        setNewPasswordState(newPw);
        setCheckPasswordState(checkPw);

        if (!pw || !newPw || !checkPw) return;

        if (!validatePassword(newPassword)) {
            setErrorResetMsg(
                "새 비밀번호가 규칙을 충족하지 않습니다. 대문자, 소문자, 숫자, 특수문자를 포함하고 연속/반복 패턴 없이 8~16자로 입력해주세요."
            );
            return;
        }

        if (newPassword.length < 8 || newPassword.length > 16) {
            setLengthPasswordState(false);
            return;
        } else {
            setLengthPasswordState(true);
        }

        if (newPassword !== checkPassword) {
            setSamePasswordState(false);
            return;
        } else {
            setSamePasswordState(true);

            const userData = {
                username: id,
                newPassword: newPassword,
            };

            // provider가 없으면 현재 비밀번호도 포함
            if (!skipCurrentPasswordCheck) {
                userData.password = password;
            }

            const url = `${process.env.REACT_APP_SPRING_API_URL}/api/newPw`;

            axios
                .post(url, userData, { withCredentials: true })
                .then((response) => {
                    alert("갱신되었습니다\n 다시 로그인해주세요");
                    handleLogout(navigate, setId, setName, setBirthDate);
                })
                .catch((error) => {
                    const msg = error.response?.data || "오류가 발생했습니다.";
                    setErrorResetMsg(msg);
                });
        }
    };

    const resetPasswordToggleBox = () => {
        setResetPasswordBox((prev) => {
            const newState = !prev;
            setPassword("");
            setNewPassword("");
            setCheckPassword("");
            setErrorResetMsg("");

            setPasswordState(true);
            setNewPasswordState(true);
            setCheckPasswordState(true);

            // 배경 높이 조정
            const background = document.querySelector(".MyPage-img");
            if (background) {
                background.style.height = newState ? "150%" : "110%";
            }

            return newState;
        });
    };

    const DeletePasswordToggleBox = () => {
        setDeletePasswordBox(!DeletePasswordBox);
        setDeletePassword("");
        setDeletePasswordState(true);
        setErrorDeleteMsg("");

    };


    // 비밀번호 유효성 검사
    const validatePassword = (pw) => {
        if (pw.length < 8 || pw.length > 16) return false;

        const hasUpper = /[A-Z]/.test(pw);
        const hasLower = /[a-z]/.test(pw);
        const hasNumber = /[0-9]/.test(pw);
        const hasSpecial = /[^A-Za-z0-9]/.test(pw);

        // 동일 문자 3회 이상 반복 금지
        const repeatPattern = /(.)\1\1/;

        // 연속 패턴 금지
        const sequentialRegex =
            /(012|123|234|345|456|567|678|789|890|098|987|876|765|654|543|432|321|qwe|wer|ert|rty|tyu|yui|uio|iop|poi|oiu|iuy|uyt|ytr|tre|rew|ewq|asd|sdf|dfg|fgh|ghj|hjk|jkl|lkj|kjh|jhg|hgf|gfd|fds|dsa|zxc|xcv|cvb|vbn|bnm|mnb|nbv|bvc|vcx|cxz)/i;

        return hasUpper && hasLower && hasNumber && hasSpecial && !repeatPattern.test(pw) && !sequentialRegex.test(pw);
    };

    // 비밀번호 강도 계산 (가입 가능 기준과 동일)
    const calculateStrength = (pw) => {
        let score = 0;

        if (pw.length >= 8 && pw.length <= 16) score++;
        if (/[A-Z]/.test(pw)) score++;
        if (/[a-z]/.test(pw)) score++;
        if (/[0-9]/.test(pw)) score++;
        if (/[^A-Za-z0-9]/.test(pw)) score++;

        const repeatPattern = /(.)\1\1/;
        if (!repeatPattern.test(pw)) score++;

        const sequentialRegex =
            /(012|123|234|345|456|567|678|789|890|098|987|876|765|654|543|432|321|qwe|wer|ert|rty|tyu|yui|uio|iop|poi|oiu|iuy|uyt|ytr|tre|rew|ewq|asd|sdf|dfg|fgh|ghj|hjk|jkl|lkj|kjh|jhg|hgf|gfd|fds|dsa|zxc|xcv|cvb|vbn|bnm|mnb|nbv|bvc|vcx|cxz)/i;
        if (!sequentialRegex.test(pw)) score++;

        return score; // 최대 7점
    };

    // 강도 표시를 가입 가능 기준과 일치시키기
    const getStrengthLabel = (score) => {
        if (score < 6) return "약함";
        if (score === 6) return "보통";
        if (score === 7) return "강함";
    };


    return (
        <div className="MyPage">
            <Header />
            <div className="MyPage-img"></div>
            <header className="MyPage-header">
                <div className="MyPage-home-container">
                    <button
                        className="MyPage-home-button"
                        type="button"
                        onClick={() => navigate("/")}
                    >
                        <img
                            className="MyPage-home-button-img"
                            src="/snake.png"
                            alt="타이틀 이미지"
                        />
                    </button>
                </div>
                <div className="MyPage-container">
                    <div className="MyPage-container-element">
                        <div className="MyPage-element">
                            <p>이름</p>
                        </div>
                        <div className="MyPage-element-value">
                            <p>{name}</p>
                        </div>
                    </div>

                    <div className="MyPage-container-element">
                        <div className="MyPage-element">
                            <p>생년월일</p>
                        </div>
                        <div className="MyPage-element-value">
                            <p>{birthDate}</p>
                        </div>
                    </div>

                    <div className="MyPage-container-element">
                        <div className="MyPage-element">
                            <p>아이디</p>
                        </div>
                        <div className="MyPage-element-value">
                            <p>{id}</p>
                        </div>
                    </div>

                    <div className="MyPage-container-element">
                        <div className="MyPage-element">
                            <p>비밀번호</p>
                        </div>
                        <div className="MyPage-element-value">
                            <button
                                className="MyPage-element-button"
                                onClick={resetPasswordToggleBox}
                            >
                                변경하기
                            </button>
                        </div>
                    </div>


                    {resetPasswordBox && (
                        provider ? (
                            // ✅ OAuth 로그인 사용자
                            <div className="MyPage-container-pw">
                                <div className="MyPage-element"></div>
                                <div className="MyPage-element-value">
                                    <p style={{ color: "red", fontWeight: "bold", fontSize: 18 }}>
                                        OAuth 사용자는 비밀번호를 변경하실 수 없습니다.
                                    </p>
                                </div>
                            </div>
                        ) : (
                            // ✅ 일반 로그인 사용자
                            <>
                                <div className="MyPage-container-pw">
                                    <div className="MyPage-element">
                                        <p>현재 비밀번호</p>
                                    </div>
                                    <div className="MyPage-element-value">
                                        <input
                                            className="MyPage-pw"
                                            type="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            placeholder="현재 비밀번호"
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleResetPassword();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="MyPage-container-pw">
                                    <div className="MyPage-element">
                                        <p>새 비밀번호</p>
                                    </div>
                                    {showPwRule && (
                                        <div className="pw-rule-box-mp">
                                            <ul>
                                                <li>✔ 8~16자 입력</li>
                                                <li>✔ 대문자 포함 (A~Z)</li>
                                                <li>✔ 소문자 포함 (a~z)</li>
                                                <li>✔ 숫자 포함 (0~9)</li>
                                                <li>✔ 특수문자 포함 (! @ # 등)</li>
                                                <li>❌ 동일 문자 3회 반복 금지</li>
                                                <li>❌ 연속 패턴 금지</li>
                                            </ul>
                                        </div>
                                    )}
                                    <div className="MyPage-element-value">
                                        <button
                                            className="SignUp-auth-button"
                                            type="button"
                                            onClick={() => setShowPwRule(prev => !prev)}
                                            style={{background: 'white'}}
                                        >
                                            {showPwRule ? "닫기" : "비밀번호 설명"}
                                        </button>
                                    </div>
                                    <div className="SignUp-auth-box">
                                        <button
                                            className="SignUp-auth-button"
                                            onClick={() => setShowPassword(prev => !prev)}
                                            type="button"
                                            style={{background: 'white'}}
                                        >
                                            {showPassword ? "숨기기" : "표시"}
                                        </button>
                                    </div>
                                    <div className="MyPage-element-value">
                                        <input
                                            className="MyPage-pw"
                                            placeholder="새 비밀번호"
                                            type={showPassword ? "text" : "password"}
                                            value={newPassword}
                                            onChange={(e) => {
                                                const pw = e.target.value;
                                                setNewPassword(pw);
                                                setPasswordStrength(calculateStrength(pw)); // 강도 업데이트
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleResetPassword();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="MyPage-container-pw">
                                    <p className="MyPage-element">비밀번호 강도</p>

                                    <div className="strength-bar">
                                        <div
                                            className="strength-fill"
                                            style={{
                                                width: `${(passwordStrength / 7) * 100}%`,
                                                backgroundColor:
                                                    passwordStrength < 6
                                                        ? "red"
                                                        : passwordStrength === 6
                                                            ? "orange"
                                                            : "green",
                                            }}
                                        ></div>
                                    </div>

                                    <p className="strength-text">
                                        {getStrengthLabel(passwordStrength)}
                                    </p>
                                </div>
                                <div className="MyPage-container-pw">
                                    <div className="MyPage-element">
                                        <p>새 비밀번호 확인</p>
                                    </div>
                                    <div className="MyPage-element-value">
                                        <input
                                            className="MyPage-pw"
                                            placeholder="새 비밀번호 확인"
                                            type="password"
                                            value={checkPassword}
                                            onChange={(e) => setCheckPassword(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleResetPassword();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                {(!passwordState || !newPasswordState || !checkPasswordState) && (
                                    <div className="MyPage-container-pw">
                                        <div className="MyPage-element"></div>
                                        <div className="MyPage-element-value" style={{ width: 650 }}>
                                            <p style={{ color: "red", fontWeight: "bold", fontSize: 18 }}>
                                                {[
                                                    !passwordState && "현재 비밀번호",
                                                    !newPasswordState && "새 비밀번호",
                                                    !checkPasswordState && "새 비밀번호 확인"
                                                ].filter(Boolean).join(", ")}
                                            </p>
                                            <p style={{ fontWeight: 10, fontSize: 18, color: "red" }}>
                                                을(를) 입력해 주세요.
                                            </p>
                                        </div>
                                    </div>
                                )}

                                {!lengthPasswordState && (
                                    <div className="MyPage-container-pw">
                                        <div className="MyPage-element"></div>
                                        <div className="MyPage-element-value" style={{ width: 650 }}>
                                            <p style={{ color: "red", fontWeight: "bold", fontSize: 18 }}>
                                                새 비밀번호 길이는 최소 8글자 최대 16글자입니다.
                                            </p>
                                        </div>
                                    </div>
                                )}

                                {!samePasswordState && (
                                    <div className="MyPage-container-pw">
                                        <div className="MyPage-element"></div>
                                        <div className="MyPage-element-value" style={{ width: 650 }}>
                                            <p style={{ color: "red", fontWeight: "bold", fontSize: 18 }}>
                                                새 비밀번호와 비밀번호 확인이 일치하지 않습니다.
                                            </p>
                                        </div>
                                    </div>
                                )}

                                {errorResetMsg && (
                                    <div className="MyPage-container-pw">
                                        <div className="MyPage-element"></div>
                                        <div className="MyPage-element-value" style={{ width: 650 }}>
                                            <p style={{ color: "red", fontWeight: "bold", fontSize: 18 }}>
                                                {errorResetMsg}
                                            </p>
                                        </div>
                                    </div>
                                )}

                                <div className="MyPage-container-pw">
                                    <div className="MyPage-element">
                                        <p>변경하기</p>
                                    </div>
                                    {(password === "" || newPassword === "" || checkPassword === "") ? (
                                        <div className="MyPage-element-value">
                                            <button
                                                className="MyPage-check"
                                                onClick={handleResetPassword}
                                                style={{ background: "gray" }}
                                            >
                                                변경
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="MyPage-element-value">
                                            <button
                                                className="MyPage-check"
                                                onClick={handleResetPassword}
                                            >
                                                변경
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </>
                        )
                    )}

                    <div className="MyPage-container-element">
                        <div className="MyPage-element">
                            <p>이메일</p>
                        </div>
                        <div className="MyPage-element-value">
                            <p>{email}</p>
                        </div>
                    </div>
                    <div className="MyPage-container-element">
                        <div className="MyPage-element">
                            <p>회원 탈퇴</p>
                        </div>
                        <div className="MyPage-element-value">
                            <button
                                className="MyPage-element-button"
                                onClick={DeletePasswordToggleBox}
                            >
                                탈퇴
                            </button>
                        </div>
                    </div>
                    {DeletePasswordBox && (
                        <>
                            {provider ? (
                                // ✅ OAuth 회원일 경우 — 비밀번호 없이 삭제 버튼만
                                <div className="MyPage-container-pw">
                                    <div className="MyPage-element">
                                        <p>회원 탈퇴</p>
                                    </div>
                                    <div className="MyPage-element-value">
                                        <button className="MyPage-check" onClick={handleDeleteUser}>
                                            삭제
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                // ✅ 일반 회원일 경우 — 기존 로직 유지
                                <>
                                    <div className="MyPage-container-pw">
                                        <div className="MyPage-element">
                                            <p>현재 비밀번호</p>
                                        </div>
                                        <div className="MyPage-element-value">
                                            <input
                                                className="MyPage-pw"
                                                type="password"
                                                value={deletePassword}
                                                onChange={(e) => setDeletePassword(e.target.value)}
                                                placeholder="비밀번호 입력"
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        handleDeleteUser();
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {!deletePasswordState && (
                                        <div className="MyPage-container-pw">
                                            <div className="MyPage-element"></div>
                                            <div className="MyPage-element-value" style={{ width: 600 }}>
                                                <p style={{ color: "red", fontWeight: "bold", fontSize: 18 }}>
                                                    비밀번호를 입력해 주세요.
                                                </p>
                                            </div>
                                        </div>
                                    )}

                                    {errorDeleteMsg && (
                                        <div className="MyPage-container-pw">
                                            <div className="MyPage-element"></div>
                                            <div className="MyPage-element-value" style={{ width: 650 }}>
                                                <p style={{ color: "red", fontWeight: "bold", fontSize: 18 }}>
                                                    {errorDeleteMsg}
                                                </p>
                                            </div>
                                        </div>
                                    )}

                                    <div className="MyPage-container-pw">
                                        <div className="MyPage-element">
                                            <p>삭제하기</p>
                                        </div>
                                        {deletePassword === "" ? (
                                            <div className="MyPage-element-value">
                                                <button
                                                    className="MyPage-check"
                                                    onClick={handleDeleteUser}
                                                    style={{ background: "gray" }}
                                                >
                                                    삭제
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="MyPage-element-value">
                                                <button className="MyPage-check" onClick={handleDeleteUser}>
                                                    삭제
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </div>
            </header>

            <Footer />
        </div>
    );
}

export default MyPage;
